import {BaseDto} from 'common';
import {SubscriptionPaymentDto} from './subscriptionPayment.dto';

/**
 * reflects RecentAccountActivitySubscriptionDto dto on server
 */
export class RecentAccountActivitySubscriptionDto extends BaseDto {
    static readonly DAY_IN_MS = 1000 * 60 * 60 * 24;

    subscription: string;
    subscriptionSource: string;
    subscriptionAuthor: string;
    notes: string;
    subscribedOn: number;
    renewalStatus: boolean;
    duration: number;
    enabled: boolean;
    subscriptionPeriodUnit: string;
    active: boolean;
    lastPayment: number;
    nextPayment: number;
    expirationDate: number;
    payments: SubscriptionPaymentDto[];
    errorNotes: string;

    public deserialize(input: any): this {
        Object.assign(this, input);

        this.payments = this.deserializeArray(input.payments, SubscriptionPaymentDto);

        return this;
    }
}
